import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TransactionData } from '../api-request';
import { ApiResponse, TransactionFees } from '../api-response';
import { FormBuilder, FormsModule } from '@angular/forms';
import { AppService } from '../app.service';
import { postTransactionMessage } from '../events';
import { PaymentProcessor, StringHelper } from '../strings-helper';
import { Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SvgComponent } from '../svg/svg.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'paywithopay-channel',
  templateUrl: './paywithopay-channel.component.html',
  styleUrls: ['./paywithopay-channel.component.scss'],
  imports: [SvgComponent, CommonModule, FormsModule],
})
export class PaywithopayChannelComponent implements OnInit, OnDestroy {
  @Input() activeTab: any = null;
  @Output() onComplete: any = new EventEmitter<any>();
  @Output() onClose: any = new EventEmitter<any>();
  @Output() onRedirect: any = new EventEmitter<any>();
  error: boolean = false;
  loading: boolean = false;

  state = {
    visible: false,
    isInitialized: false,
    completed: false,
    loaded: false,
    isFilling: false,
    error: false,
    verifyingOpay: false,
  };
  responseData: any;
  bankOption: any = null;
  transactionData!: TransactionData;
  amount: any;
  currency: any;
  transactionFees!: TransactionFees;
  reference!: string;
  errorMessage!: string;
  callback: any = {};
  paymentProcessor: any;
  private timer$: Subscription | undefined;
  iframe!: HTMLIFrameElement;
  cardinalCallbackUrl: string = 'https://zestpayment.com/loader.html';
  queryTime: number = environment.txnQueryTime / 2; // 10 minutes
  isIntervalActive: boolean = true;

  private setState(key: any, value: any) {
    this.state = { ...this.state, [key]: value };
    this.cd.detectChanges();
  }

  constructor(
    private formBuilder: FormBuilder,
    private appService: AppService,
    private cd: ChangeDetectorRef,
    private el: ElementRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.state.visible) {
      if (changes['activeTab'].currentValue === 'paywithopay-tab') {
        this.setState('isFilling', true);
        this.setState('error', false);
      }
    }
  }

  ngAfterViewInit(): void {
    this.appService.getData().subscribe({
      next: (res) => {
        this.transactionData = res.txnData;
        this.reference = res.txnRef;
        this.transactionFees = res.transactionFees;
        this.amount = StringHelper.toMajorAmount(
          +this.transactionData.amount + this.transactionFees.WEB_OPAY,
        );
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  ngOnInit(): void {}

  paymentDone() {
    this.onComplete.emit(this.callback);
    const domEvent = new CustomEvent('paymentDone');
    this.el.nativeElement.dispatchEvent(domEvent);
  }

  paymentFailed() {
    const error = {
      reference: this.reference,
      message: this.errorMessage,
      status: 'failure',
    };
    postTransactionMessage('error', error);
    const domEvent = new CustomEvent('paymentFailed');
    this.el.nativeElement.dispatchEvent(domEvent);
  }

  removeIFrame() {
    const frameId = 'payWithOpayTarget';
    const frame = document.getElementById(frameId) as HTMLIFrameElement;
    frame.parentNode?.removeChild(frame);
  }

  onSubmitBtnClicked() {
    this.loading = true;
    const payload = {
      reference: this.reference,
      amount: this.amount,
      opayRequestType: 'INITIATE_PAYMENT',
    };

    console.log(payload);

    this.appService.paywithopayRequest(payload).subscribe({
      next: (res) => {
        this.loading = false;
        if (res?.data?.cashierUrl) {
          this.initiateOpayPayment(res?.data?.cashierUrl);
        }
      },
      error: (err) => {
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.loading = false;
        this.setState('error', true);
      },
    });
  }

  initiateOpayPayment(cashierUrl: string) {
    this.paymentProcessor = PaymentProcessor.OPAY;
    this.onRedirect.emit();
    const iframe = document.getElementById(
      'payWithOpayTarget',
    ) as HTMLIFrameElement;
    if (!iframe) {
      this.errorMessage = 'Unable to load OPay iframe';
      this.setState('error', true);
      return;
    }

    iframe.src = cashierUrl;
    // Style iframe to be full screen
    iframe.style.cssText = `
        display: block;
        z-index: 999999999999999;
        background: #FFF;
        border: none;
        overflow: hidden;
        margin: 0;
        padding: 0;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      `;

    const this$ = this;
    iframe.addEventListener('load', function onFirstLoad() {
      iframe.addEventListener(
        'load',
        () => {
          this$.checkIframeContentChange();
        },
        { once: true },
      );

      iframe.removeEventListener('load', onFirstLoad);
    });
  }

  checkIframeContentChange() {
    const frameId = 'payWithOpayTarget';
    const frame = document.getElementById(frameId) as HTMLIFrameElement;
    // detecting if iframe URL has changed
    this.cd.detectChanges();

    this.confirmTransaction();
  }

  confirmTransaction() {
    this.setState('verifyingOpay', true);
    const data = {
      transactionRef: this.reference,
    };
    this.appService.confirmOpayPayment(data).subscribe({
      next: (res: ApiResponse) => {
        if (res) {
          if (res.status === 'IN PROGRESS') {
            this.beginQuery();
            this.removeIFrame();
            return;
          } else if (res.status === 'FAILED' || res.status === 'CLOSED') {
            this.errorMessage = StringHelper.getErrorMessage(
              res.data.narration,
            );
            this.setState('verifyingOpay', false);
            this.setState('error', true);
            this.removeIFrame();
            this.paymentFailed();
          } else {
            this.setState('verifyingOpay', false);
            this.removeIFrame();
            //this.callback.url = res.data.redirectHtml;
            this.paymentDone();
          }
        }
      },
      error: (err) => {
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingOpay', false);
        this.setState('error', true);
        this.removeIFrame();
        this.paymentFailed();
      },
    });
  }

  beginQuery() {
    this.startInterval();
  }

  startInterval() {
    this.timer$ = timer(0, 10000).subscribe((tick: any) => {
      if (!this.isIntervalActive) {
        // Stop further execution if the interval is not active
        return;
      }

      if (tick == this.queryTime) {
        this.errorMessage = `We could not confirm your payment.`;

        setTimeout(() => {
          this.setState('verifyingOpay', false);
          this.setState('error', true);
          this.paymentFailed();
        }, 5000);
      } else if (tick == this.queryTime + 2) {
        this.stopInterval();
        this.removeIFrame();
      } else {
        // Your API call, which will be performed every 10000 milliseconds
        this.queryTransaction();
      }
    });
  }

  stopInterval() {
    this.isIntervalActive = false;

    if (this.timer$) {
      this.timer$.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.timer$?.unsubscribe();
  }

  queryTransaction() {
    const data = {
      transactionRef: this.reference,
    };
    this.appService.confirmOpayPayment(data).subscribe({
      next: (res: ApiResponse) => {
        if (res) {
          if (res.status === 'IN PROGRESS') {
            this.loading = true;
            return;
          } else if (res.status === 'FAILED') {
            this.errorMessage = StringHelper.getErrorMessage(
              res.data.narration,
            );
            this.loading = false;
            this.setState('verifyingOpay', false);
            this.setState('error', true);
            this.removeIFrame();
            this.stopInterval();
            this.paymentFailed();
          } else {
            this.setState('verifyingOpay', false);
            this.loading = false;
            this.removeIFrame();
            this.paymentDone();
            this.stopInterval();
          }
        }
      },
      error: (err) => {
        this.errorMessage = StringHelper.getErrorMessage(err.error);
        this.setState('verifyingOpay', false);
        this.setState('error', true);
        this.removeIFrame();
        this.stopInterval();
        this.paymentFailed();
      },
    });
  }
}
